/**
 * Blob を指定ファイル名でダウンロードさせる。
 * file-saver の `saveAs(blob, filename)` 互換の最小実装。
 */
export function saveAs(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  // 同期で revoke するとブラウザが Blob を読み取る前に URL が解放され、
  // 一部ブラウザ（Firefox / Safari）でダウンロードが失敗するため遅延させる
  setTimeout(() => URL.revokeObjectURL(url), 100);
}

export default saveAs;
